import { createQueryFactory } from "#resources/hooks/integrations/query-factory";

/**
 * Hook API getRetrospective
 *
 * @example
 * const { data, isLoading, error } = useGetRetrospective({
 *   year: 2025,
 *   placeIds: ["place-id-1", "place-id-2"]
 * });
 */
export const { useApiHook: useGetRetrospective } = createQueryFactory(
	"getRetrospective",
	{
		retry: false,
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		staleTime: 1000 * 60 * 5, // 5 min
		gcTime: 1000 * 60 * 30, // 30 min
	},
);
